
import { NotificationManager } from './NotificationManager';
import { UserNotificationRouting } from '@/types/notificationConfig';

// Create a singleton instance of NotificationManager
export const notificationManager = NotificationManager.getInstance();

// Export the functions from the notification manager instance
export const getNotificationConfig = (category?: string) => 
  notificationManager.getNotificationConfig(category);
  
export const saveNotificationConfig = (config: any, category: string) => 
  notificationManager.setNotificationConfig(config, category);
  
export const getUserRoutingConfig = () => 
  notificationManager.getUserRoutingConfig();
  
export const setUserRoutingConfig = (config: UserNotificationRouting) => 
  notificationManager.setUserRoutingConfig(config);

export default notificationManager;
